import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Placeholder } from "../../models/placeholder.model";
import { CpaService } from "../../services/cpa.service";

@Component({
  selector: 'app-cpa-accounts-dialog',
  templateUrl: './cpa-accounts-dialog.component.html',
  styleUrls: ['./cpa-accounts-dialog.component.css']
})
export class CpaAccountsDialog implements OnInit {

  accounts: string[];
  loading: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { cpaCode: string, locale: string },
    private service: CpaService
  ) { }

  get placeholders(): Placeholder[] {
    return [
      Placeholder.create("cpaId", this.data.cpaCode, true),
    ];
  }

  ngOnInit(): void {
    this.loading = true;
    this.service.getAccounts(this.data.cpaCode).subscribe(accounts => {
      this.accounts = accounts;
      this.loading = false;
    })
  }

}